import Cookies from 'universal-cookie';
import * as dateFns from 'date-fns';

const cookies = new Cookies(null, {
  sameSite: 'lax',
  domain: process.env.COOKIE_DOMAIN,
  secure: !!process.env.COOKIE_SECURE,
  path: '/',
});

export function getUser() {
  const cookie = getUserCookie();
  if (cookie) return cookie;
  // FALLBACK: use local/session storage, TODO: remove this
  // const userStr =
  //   localStorage.getItem('user') ?? sessionStorage.getItem('user');
  // if (userStr) {
  //   try {
  //     return JSON.parse(userStr);
  //   } catch (err) {
  //     if (err instanceof SyntaxError) return null;
  //     throw err;
  //   }
  // }
  return null;
}

export function getUserCookie() {
  const user = cookies.get('user');
  if (!user) return null;
  return user;
}

export function setUser(user, session = false) {
  cookies.set('user', user, {
    expires: dateFns.addDays(new Date(), 14),
  });
  // BACKWARDS-COMPATIBILITY with anonymous users, TODO: remove this
  if (session) sessionStorage.setItem('user', JSON.stringify(user));
}

export function clearUser() {
  cookies.remove('user');
  localStorage.clear();
  sessionStorage.clear();
}

export function isImpersonating() {
  try {
    const user = sessionStorage.getItem('user');

    if (!user) {
      return false;
    }

    const parsedUser = JSON.parse(user);

    if (parsedUser && parsedUser.is_anonymous) {
      return false;
    }

    return user !== null;
  } catch {
    return false;
  }
}
